import { Injectable } from '@angular/core';
import { AUTH_CUSTOMER, RBAC_STATE, ROLE_DATA } from '../constants/constants';
import { Customer, RbacState, Role } from '../models/payload';

@Injectable({
  providedIn: 'root',
})
export class StorageService {

  clear(): void {
    window.sessionStorage.clear();
  }

  removeSaveData(key: string): void {
    const data = window.sessionStorage.getItem(key);
    if (data) {
      window.sessionStorage.removeItem(key)
    }
  }

  public saveCustomerInfo(customer: Customer[]): void {
    window.sessionStorage.removeItem(AUTH_CUSTOMER);
    window.sessionStorage.setItem(AUTH_CUSTOMER, JSON.stringify(customer));
  }

  public getCustomerInfo(): Customer[] | null {
    const customer = window.sessionStorage.getItem(AUTH_CUSTOMER);
    if (customer) {
      return JSON.parse(customer);
    }
    return null;
  }

  public isLoggedIn(): boolean {
    const customer = window.sessionStorage.getItem(AUTH_CUSTOMER);
    if (customer) {
      return true;
    }
    return false;
  }

  public setData(key:string , data: any): void {
    window.sessionStorage.removeItem(key);
    window.sessionStorage.setItem(key, JSON.stringify(data));
  }

  public getData(key: string): any | null {
    const data = window.sessionStorage.getItem(key);
    if (data) {
      return JSON.parse(data);
    }
    return null;
  }

  public saveRoleInformation(role: Role): void {
    window.sessionStorage.removeItem(ROLE_DATA);
    window.sessionStorage.setItem(ROLE_DATA, JSON.stringify(role));
  }

  public getRoleInformation(): Role | null {
    const role = window.sessionStorage.getItem(ROLE_DATA);
    if (role) {
      return JSON.parse(role);
    }
    return null;
  }

  public getCustomersListSessionStorage(): string[] {
    const customer = window.sessionStorage.getItem(AUTH_CUSTOMER);
    if (customer) {
      const customerInfo = JSON.parse(customer);
      return customerInfo.map((x: Customer) => x.customerNumber);
    }
    return [];
  }

  public setRbacState(state: RbacState): void {
    window.sessionStorage.removeItem(RBAC_STATE);
    window.sessionStorage.setItem(RBAC_STATE, JSON.stringify(state));
  }

  public getRbacState(): RbacState | null {
    const data = window.sessionStorage.getItem(RBAC_STATE);
    return data ? (JSON.parse(data) as RbacState) : null;
  }

  public clearRbacState(): void {
    window.sessionStorage.removeItem(RBAC_STATE);
  }

}
